<div class="school-context-demo">
  <div class="demo-header">
    <h2>School Context Demo</h2>
    <p>This component demonstrates how the UI dynamically adapts based on school type.</p>
  </div>

  <!-- School Type Selector -->
  <div class="school-type-selector">
    <h3>Current School Type: {{ getSchoolTypeDisplayName(currentSchoolType) }}</h3>
    <div class="type-buttons">
      <button *ngFor="let type of availableSchoolTypes" [class.active]="type === currentSchoolType"
        (click)="changeSchoolType(type)" class="type-btn">
        {{ getSchoolTypeDisplayName(type) }}
      </button>
    </div>
  </div>

  <!-- Dynamic Labels Display -->
  <div class="labels-section">
    <h3>Dynamic Labels</h3>
    <div class="labels-grid">
      <div class="label-item">
        <strong>Subject/Course:</strong>
        <span>{{ allLabels.subject }}</span>
      </div>
      <div class="label-item">
        <strong>Student/Learner:</strong>
        <span>{{ allLabels.student }}</span>
      </div>
      <div class="label-item">
        <strong>Evaluation/Assessment:</strong>
        <span>{{ allLabels.evaluation }}</span>
      </div>
      <div class="label-item">
        <strong>Term/Semester:</strong>
        <span>{{ allLabels.term }}</span>
      </div>
      <div class="label-item">
        <strong>Course Registration:</strong>
        <span>{{ allLabels.courseRegistration }}</span>
      </div>
      <div class="label-item">
        <strong>Student Registration:</strong>
        <span>{{ allLabels.studentRegistration }}</span>
      </div>
      <div class="label-item">
        <strong>Academic Level:</strong>
        <span>{{ allLabels.academicLevel }}</span>
      </div>
      <div class="label-item">
        <strong>Sequence:</strong>
        <span>{{ allLabels.sequence }}</span>
      </div>
      <div class="label-item">
        <strong>Department:</strong>
        <span>{{ allLabels.department }}</span>
      </div>
      <div class="label-item">
        <strong>Specialization:</strong>
        <span>{{ allLabels.specialization }}</span>
      </div>
    </div>
  </div>

  <!-- Features Display -->
  <div class="features-section">
    <h3>Feature Flags</h3>
    <div class="features-grid">
      <div class="feature-item">
        <strong>Requires Course Registration:</strong>
        <span [class.enabled]="features.requiresCourseRegistration"
          [class.disabled]="!features.requiresCourseRegistration">
          {{ features.requiresCourseRegistration ? 'Yes' : 'No' }}
        </span>
      </div>
      <div class="feature-item">
        <strong>Requires Student Registration:</strong>
        <span [class.enabled]="features.requiresStudentRegistration"
          [class.disabled]="!features.requiresStudentRegistration">
          {{ features.requiresStudentRegistration ? 'Yes' : 'No' }}
        </span>
      </div>
      <div class="feature-item">
        <strong>Uses Semesters:</strong>
        <span [class.enabled]="features.usesSemesters" [class.disabled]="!features.usesSemesters">
          {{ features.usesSemesters ? 'Yes' : 'No' }}
        </span>
      </div>
      <div class="feature-item">
        <strong>Uses Terms:</strong>
        <span [class.enabled]="features.usesTerms" [class.disabled]="!features.usesTerms">
          {{ features.usesTerms ? 'Yes' : 'No' }}
        </span>
      </div>
      <div class="feature-item">
        <strong>Uses Sequences:</strong>
        <span [class.enabled]="features.usesSequences" [class.disabled]="!features.usesSequences">
          {{ features.usesSequences ? 'Yes' : 'No' }}
        </span>
      </div>
    </div>
  </div>

  <!-- Usage Examples -->
  <div class="usage-section">
    <h3>Usage Examples</h3>
    <div class="usage-examples">
      <div class="example">
        <h4>Using the Directive:</h4>
        <code>&lt;span appDynamicLabel="subject"&gt;&lt;/span&gt;</code>
        <p>Result: <span appDynamicLabel="subject"></span></p>
      </div>

      <div class="example">
        <h4>Using the Pipe:</h4>
        <code>{{ '{{ \'student\' | dynamicLabel | async }}' }}</code>
        <p>Result: {{ allLabels.student }}</p>
      </div>

      <div class="example">
        <h4>Using the Service in Component:</h4>
        <code>this.dynamicLabelService.subjectLabel.subscribe(label => ...)</code>
        <p>Result: {{ allLabels.subject }}</p>
      </div>
    </div>
  </div>
</div>